
import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Button,
    Badge,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Label,
    Input,
    FormFeedback,
} from "reactstrap"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import * as Yup from "yup"
import { useFormik } from "formik"

//Import Action
import {
    setBreadcrumbItems,
    getPlans,
    addNewPlan,
    updatePlan,
    deletePlan,
} from "../../../store/actions"

const PlansList = props => {
    document.title = "Plans d'Abonnement | CRM Admin"

    const [modal, setModal] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [currentPlan, setCurrentPlan] = useState(null)

    const breadcrumbItems = [
        { title: "CRM", link: "#" },
        { title: "Admin", link: "#" },
        { title: "Plans d'Abonnement", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Plans", breadcrumbItems)
        props.getPlans()
    }, [])

    const toggle = () => {
        if (modal) {
            setModal(false)
            setCurrentPlan(null)
            setIsEdit(false)
        } else {
            setModal(true)
        }
    }

    const handlePlanClick = arg => {
        const plan = arg
        setCurrentPlan({
            id: plan.id,
            name: plan.name,
            description: plan.description || "",
            duration_months: plan.duration_months,
            price: plan.price,
            discount_percentage: plan.discount_percentage || 0,
            customer_limit: plan.customer_limit,
            user_limit: plan.user_limit,
            email_credits: plan.email_credits || 0,
            whatsapp_credits: plan.whatsapp_credits || 0,
            features: Array.isArray(plan.features) ? plan.features : [],
            is_active: plan.is_active,
            is_trial: plan.is_trial,
            trial_days: plan.trial_days || 0,
        })
        setIsEdit(true)
        toggle()
    }

    const handleDeletePlan = plan => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer ce plan ?")) {
            props.deletePlan(plan)
        }
    }

    const [featureInput, setFeatureInput] = useState("")

    const addFeature = () => {
        if (featureInput.trim()) {
            const currentFeatures = validation.values.features || []
            validation.setFieldValue("features", [...currentFeatures, featureInput.trim()])
            setFeatureInput("")
        }
    }

    const removeFeature = (index) => {
        const currentFeatures = validation.values.features || []
        const updatedFeatures = currentFeatures.filter((_, i) => i !== index)
        validation.setFieldValue("features", updatedFeatures)
    }

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: (currentPlan && currentPlan.name) || "",
            description: (currentPlan && currentPlan.description) || "",
            duration_months: (currentPlan && currentPlan.duration_months) || 1,
            price: (currentPlan && currentPlan.price) || 0,
            discount_percentage: (currentPlan && currentPlan.discount_percentage) || 0,
            customer_limit: (currentPlan && currentPlan.customer_limit) || 10,
            user_limit: (currentPlan && currentPlan.user_limit) || 1,
            email_credits: (currentPlan && currentPlan.email_credits) || 0,
            whatsapp_credits: (currentPlan && currentPlan.whatsapp_credits) || 0,
            features: (currentPlan && currentPlan.features) || [],
            is_active: (currentPlan && currentPlan.is_active) ?? true,
            is_trial: (currentPlan && currentPlan.is_trial) ?? false,
            trial_days: (currentPlan && currentPlan.trial_days) || 0,
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Veuillez saisir le nom du plan"),
            duration_months: Yup.number().required().min(1),
            price: Yup.number().required().min(0),
            customer_limit: Yup.number().required().min(1),
            user_limit: Yup.number().required().min(1),
        }),
        onSubmit: values => {
            if (isEdit) {
                const updatePlanData = {
                    id: currentPlan.id,
                    ...values,
                }
                props.updatePlan(updatePlanData)
            } else {
                props.addNewPlan(values)
            }
            toggle()
        },
    })

    return (
        <React.Fragment>
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <div className="d-flex align-items-center justify-content-between mb-4">
                                <CardTitle className="h4 mb-0">Plans d'Abonnement</CardTitle>
                                <Button color="primary" onClick={toggle}>
                                    <i className="mdi mdi-plus me-1"></i> Créer un Plan
                                </Button>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-centered table-nowrap mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Nom</th>
                                            <th>Fonctionnalités</th>
                                            <th>Durée</th>
                                            <th>Prix</th>
                                            <th>Limites</th>
                                            <th>Statut</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props.plans.map((plan, key) => (
                                            <tr key={key}>
                                                <td style={{ width: "200px" }}>
                                                    <h5 className="font-size-14 mb-1 text-truncate">{plan.name}</h5>
                                                    <p className="text-muted mb-0 font-size-12">{plan.slug}</p>
                                                </td>
                                                <td>
                                                    <div className="d-flex flex-wrap gap-1" style={{ maxWidth: "300px" }}>
                                                        {(() => {
                                                            let features = plan.features;
                                                            if (features && typeof features === 'string') {
                                                                try { features = JSON.parse(features); } catch (e) { features = []; }
                                                            }
                                                            if (Array.isArray(features) && features.length > 0) {
                                                                return (
                                                                    <>
                                                                        {features.slice(0, 3).map((f, i) => (
                                                                            <Badge key={i} color="light" className="text-dark border font-size-11 px-2 py-1">{f}</Badge>
                                                                        ))}
                                                                        {features.length > 3 && (
                                                                            <Badge color="light" className="text-muted border font-size-11 px-2 py-1">+{features.length - 3} de plus</Badge>
                                                                        )}
                                                                    </>
                                                                );
                                                            }
                                                            return <span className="text-muted font-size-12 italic">Aucune fonctionnalité</span>;
                                                        })()}
                                                    </div>
                                                </td>
                                                <td>{plan.duration_months} Mois</td>
                                                <td>
                                                    <div className="fw-bold">{plan.final_price} MAD</div>
                                                    {plan.discount_percentage > 0 && (
                                                        <del className="text-muted font-size-12">{plan.price} MAD</del>
                                                    )}
                                                </td>
                                                <td>
                                                    <div className="font-size-12">
                                                        <i className="mdi mdi-account-multiple me-1 text-info"></i>{plan.customer_limit} Clients<br />
                                                        <i className="mdi mdi-account-star me-1 text-primary"></i>{plan.user_limit} Utilisateurs
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex flex-column gap-1">
                                                        <Badge color={plan.is_active ? "success" : "danger"}>
                                                            {plan.is_active ? "Actif" : "Inactif"}
                                                        </Badge>
                                                        {plan.is_trial && <Badge color="info">Essai ({plan.trial_days}j)</Badge>}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex gap-2">
                                                        <Button
                                                            color="primary"
                                                            size="sm"
                                                            onClick={() => handlePlanClick(plan)}
                                                        >
                                                            <i className="mdi mdi-pencil"></i>
                                                        </Button>
                                                        <Button
                                                            color="danger"
                                                            size="sm"
                                                            onClick={() => handleDeletePlan(plan)}
                                                        >
                                                            <i className="mdi mdi-trash-can"></i>
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Modal isOpen={modal} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle} tag="h4">
                    {!!isEdit ? "Modifier le Plan" : "Ajouter un Plan"}
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                    >
                        <Row>
                            <Col md={8}>
                                <div className="mb-3">
                                    <Label>Nom du Plan</Label>
                                    <Input
                                        name="name"
                                        type="text"
                                        placeholder="ex: Basique, Premium, Entreprise"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.name || ""}
                                        invalid={validation.touched.name && validation.errors.name ? true : false}
                                    />
                                    {validation.touched.name && validation.errors.name ? (
                                        <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                                    ) : null}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="mb-3">
                                    <Label>Durée (Mois)</Label>
                                    <Input
                                        name="duration_months"
                                        type="number"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.duration_months || ""}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={4}>
                                <div className="mb-3">
                                    <Label>Prix (MAD)</Label>
                                    <Input
                                        name="price"
                                        type="number"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.price || ""}
                                    />
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="mb-3">
                                    <Label>Remise (%)</Label>
                                    <Input
                                        name="discount_percentage"
                                        type="number"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.discount_percentage || ""}
                                    />
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="mb-3">
                                    <Label>&nbsp;</Label>
                                    <div className="form-check form-switch mt-1">
                                        <Input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="is_active"
                                            name="is_active"
                                            checked={validation.values.is_active}
                                            onChange={(e) => validation.setFieldValue('is_active', e.target.checked)}
                                        />
                                        <Label className="form-check-label" htmlFor="is_active">Actif</Label>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <div className="mb-3">
                            <Label>Fonctionnalités du Plan</Label>
                            <div className="d-flex gap-2 mb-2">
                                <Input
                                    type="text"
                                    placeholder="Ajouter une fonctionnalité (ex: Factures illimitées)"
                                    value={featureInput}
                                    onChange={(e) => setFeatureInput(e.target.value)}
                                    onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addFeature())}
                                />
                                <Button type="button" color="secondary" onClick={addFeature}>Ajouter</Button>
                            </div>
                            <div className="d-flex flex-wrap gap-2 p-2 border rounded bg-light min-height-50">
                                {validation.values.features && validation.values.features.length > 0 ? (
                                    validation.values.features.map((feature, index) => (
                                        <Badge key={index} color="primary" className="p-2 d-flex align-items-center gap-2">
                                            {feature}
                                            <i
                                                className="mdi mdi-close cursor-pointer"
                                                onClick={() => removeFeature(index)}
                                                style={{ fontSize: '11px' }}
                                            ></i>
                                        </Badge>
                                    ))
                                ) : (
                                    <span className="text-muted italic font-size-12">Aucune fonctionnalité ajoutée.</span>
                                )}
                            </div>
                        </div>

                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label>Limite de Clients</Label>
                                    <Input
                                        name="customer_limit"
                                        type="number"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.customer_limit || ""}
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label>Limite d'Utilisateurs</Label>
                                    <Input
                                        name="user_limit"
                                        type="number"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.user_limit || ""}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label>Crédits Email</Label>
                                    <Input
                                        name="email_credits"
                                        type="number"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.email_credits || ""}
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label>Crédits Whatsapp</Label>
                                    <Input
                                        name="whatsapp_credits"
                                        type="number"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.whatsapp_credits || ""}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <div className="mb-3">
                            <Label>Description</Label>
                            <Input
                                name="description"
                                type="textarea"
                                rows="2"
                                placeholder="Bref résumé du plan..."
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.description || ""}
                            />
                        </div>

                        <Row>
                            <Col md={6}>
                                <div className="form-check form-switch mb-3">
                                    <Input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="is_trial"
                                        name="is_trial"
                                        checked={validation.values.is_trial}
                                        onChange={(e) => validation.setFieldValue('is_trial', e.target.checked)}
                                    />
                                    <Label className="form-check-label" htmlFor="is_trial">Plan d'Essai</Label>
                                </div>
                            </Col>
                            {validation.values.is_trial && (
                                <Col md={6}>
                                    <div className="mb-3">
                                        <Label>Jours d'Essai</Label>
                                        <Input
                                            name="trial_days"
                                            type="number"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.trial_days || ""}
                                        />
                                    </div>
                                </Col>
                            )}
                        </Row>

                        <Row>
                            <Col>
                                <div className="text-end">
                                    <Button type="button" color="secondary" className="me-2" onClick={toggle}>Annuler</Button>
                                    <Button type="submit" color="success">
                                        {isEdit ? "Mettre à jour" : "Créer le Plan"}
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        plans: state.Plans.plans,
    }
}

export default connect(mapStateToProps, {
    setBreadcrumbItems,
    getPlans,
    addNewPlan,
    updatePlan,
    deletePlan,
})(withTranslation()(PlansList))
